<div class="fc-common-panel-wrapper fc-responsive-ag-grid-simple-message">
    <div class="fc-common-panel-header">
        <h2 [ngClass]="iconClass ? iconClass : 'without-icon'">
            <span class="fc-common-panel-header-title">
                {{ title }}
            </span>
        </h2>
        <span class="fc-common-panel-header-close-btn"
              (click)="close()"></span>
    </div>
    <div class="fc-common-panel-body">
        <div [innerHTML]="message"></div>
    </div>
    <div class="fc-common-panel-footer">
        <div class="fc-common-panel-footer-buttons">
            <button class="fc-common-button modal-button white-btn-green float-left non-margin-left"
                    type="button"
                    *ngIf="showBtnCancel"
                    (click)="close()">
                <span>{{btnCancelLabel}}</span>
            </button>
            <button class="fc-common-button modal-button dark-green primary-button long-btn"
                    type="button"
                    *ngIf="showBtnOk"
                    (click)="close(true)">
                <span>{{btnOkLabel}}</span>
            </button>
        </div>
    </div>
</div>